import React from 'react';

import {
  EditSbatGroupLessonForm,
  LESSON_INPUT_OPTIONS,
  NON_LIVE_LECTURE_LESSON_TYPES,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import SbatGroupLessonChip from '../SbatGroupLessonChip';

export default function EditSbatGroupWithoutLiveLectureForm({ sbatGroup }) {
  const academyTopic = sbatGroup?.academy_topic;
  const { lessons } = academyTopic || {};

  return (
    <Field
      label="Lecture Requirements"
      labelClassName="m-b-xs"
    >
      <div className="m-b-s">
        {NON_LIVE_LECTURE_LESSON_TYPES.map((lessonType) => (
          <SbatGroupLessonChip
            sbatGroup={sbatGroup}
            lessonType={lessonType}
            title={LESSON_INPUT_OPTIONS[lessonType].label}
            key={lessonType}
          />
        ))}
      </div>
      {lessons.map((lesson) => {
        const { lesson_type: lessonType } = lesson;
        const label = LESSON_INPUT_OPTIONS[lessonType]?.label;

        return (
          label && (
            <EditableSection
              canEdit
              title={label}
              className="m-b-s"
              key={lesson.id}
            >
              {(editableProps) => (
                <div className="row">
                  <EditSbatGroupLessonForm
                    {...editableProps}
                    sbatGroup={sbatGroup}
                    value={lesson}
                    label={label}
                  />
                </div>
              )}
            </EditableSection>
          )
        );
      })}
    </Field>
  );
}
